import React from 'react';

const WebViewComponent = () => {
  return (
    <div className='w-full h-screen '>
      <iframe
        src="https://teams.igem.org/5058/attributions"
        title="WebView"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
     
        }}
      />
    </div>
  );
};

export default WebViewComponent;
